import React, { useEffect, useRef } from 'react'
import type { Message } from '../../types/index.js'

interface MessageListProps {
  messages: Message[]
  onLoadMore?: () => void
  renderMessage?: (message: Message, isStreaming: boolean) => React.ReactNode
  isStreaming?: boolean
}

function MessageItem({ message, isStreaming = false }: { message: Message; isStreaming?: boolean }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: message.role === 'user' ? 'flex-end' : 'flex-start',
      marginBottom: 12,
    }}>
      <div style={{
        maxWidth: '80%',
        padding: '8px 14px',
        borderRadius: 12,
        background: message.role === 'user' ? '#6366f1' : '#1e1e2e',
        color: '#fff',
        fontSize: 14,
        lineHeight: 1.5,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}>
        {message.content}
        {isStreaming && <span style={{ opacity: 0.7 }}>▊</span>}
      </div>
    </div>
  )
}

function MessageList({ messages, onLoadMore, renderMessage, isStreaming }: MessageListProps) {
  const endRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: 16 }}>
      {onLoadMore && (
        <button onClick={onLoadMore} style={{ alignSelf: 'center', marginBottom: 16, background: 'transparent', border: '1px solid #333', color: '#999', cursor: 'pointer', borderRadius: 8, padding: '4px 12px' }}>
          加载更多
        </button>
      )}
      {messages.map((msg, i) => {
        const streaming = !!isStreaming && i === messages.length - 1 && msg.role === 'assistant'
        return renderMessage
          ? <React.Fragment key={msg.id}>{renderMessage(msg, streaming)}</React.Fragment>
          : <MessageItem key={msg.id} message={msg} isStreaming={streaming} />
      })}
      <div ref={endRef} />
    </div>
  )
}

export const Thread = { MessageList, MessageItem }
